$(document).ready(function() {
                          // Initialize intl-tel-input for phone number input field
                          var input = document.querySelector("#phone");
                          var iti = window.intlTelInput(input, {
                              separateDialCode: true,  // To show country code in the input field
                              preferredCountries: ["in", "us", "gb", "au", "jp"],  // Customize this array to show preferred countries
                              initialCountry: "us",
                              utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.17/js/utils.js",  // This is required for formatting and validation
                          });

                          // Check if OTP was sent recently (within the last minute)
                          function checkOtpCooldown() {
                      var lastSentTime = localStorage.getItem('otpSentTime');
                      var currentTime = Date.now();

                      // Clear any existing interval to avoid multiple timers
                      clearInterval(window.otpCountdownInterval);

                      if (lastSentTime) {
                          var timeDifference = currentTime - lastSentTime;

                          // If less than 1 minute (60,000 ms) has passed
                          if (timeDifference < 60000) {
                              var remainingTime = 60000 - timeDifference;

                              // Update the button text and disable it
                              $('#sendOtpBtn').prop('disabled', true);
                              $('#sendOtpBtn').text('ReSend Code in ' + Math.ceil(remainingTime / 1000) + 's');

                              // Start a real-time countdown
                              window.otpCountdownInterval = setInterval(function () {
                                  remainingTime -= 1000;

                                  if (remainingTime > 0) {
                                      $('#sendOtpBtn').text('ReSend Code in ' + Math.ceil(remainingTime / 1000) + 's');
                                  } else {
                                      clearInterval(window.otpCountdownInterval); // Stop the timer
                                      $('#sendOtpBtn').prop('disabled', false);
                                      $('#sendOtpBtn').text('Send Code');
                                  }
                              }, 1000); // Update every second
                          } else {
                              $('#sendOtpBtn').prop('disabled', false);
                              $('#sendOtpBtn').text('Send Code');
                          }
                      } else {
                          $('#sendOtpBtn').prop('disabled', false);
                          $('#sendOtpBtn').text('Send Code');
                      }
                  }


                          // Call the checkOtpCooldown on page load to set the initial state of the button
                          checkOtpCooldown();

                          // Send Code
                          $('#sendOtpBtn').click(function() {
                              var phone = iti.getNumber();  // Get the phone number with the country code

                              if (phone) {
                                  $.ajax({
                                      url: 'https://new.magento-development.asia/christians-cva-master-app/otp-verification/send_otp.php',
                                      // url: 'https://app.christianvigilantarms.com/christians-cva-master/otp-verification/send_otp.php',
                                      type: 'POST',
                                      data: { phone: phone },
                                      success: function(response) {
                                        // alert(response);
                                        // alert(response);

                                          Swal.fire({
                                              icon: 'success',
                                              title: 'Passcode Sent!',
                                              text: 'An Passcode has been sent to your phone number.',
                                          });
                                          $(".otp_send_field").css("display","none");
                                          $(".otp_verify_field").css("display","block");
                                          // Store the current time in localStorage when OTP is sent
                                          localStorage.setItem('otpSentTime', Date.now());
                                          // Call function to disable the button and show countdown
                                          checkOtpCooldown();

                                      },
                                      error: function() {
                                          $('#response').html('Error sending passcode');
                                          Swal.fire({
                                              icon: 'error',
                                              title: 'Oops...',
                                              text: 'Error sending passcode. Please try again.',
                                          });
                                      }
                                  });
                              } else {
                                  Swal.fire({
                                      icon: 'warning',
                                      title: 'Input Required',
                                      text: 'Please enter a phone number.',
                                  });
                              }
                          });

                          // Verify OTP
                          $('#verifyOtpBtn').click(function() {
                              var phone = iti.getNumber();  // Get the phone number with the country code
                              var otp = $('#otp').val();
                              if (phone && otp) {
                                  $.ajax({
                                      url: 'https://new.magento-development.asia/christians-cva-master-app/otp-verification/verify_otp.php',
                                      // url: 'https://app.christianvigilantarms.com/christians-cva-master/otp-verification/verify_otp.php',

                                    type: 'POST',
                                      data: { phone: phone, otp: otp },
                                      success: function(response) {
                                          if(response == "OTP verification successful!"){
                                              Swal.fire({
                                                  icon: 'success',
                                                  title: 'Passcode Verified!',
                                                  text: 'Your OTP has been successfully verified.',
                                              });

                                            localStorage.setItem('mobile_verified_by_otp', '1');
                                            $('#sendOtpBtn').prop('disabled', true);
                                            $('.cst_pop_overlay').fadeOut();
                                            $(".otp_member_info").addClass("hidden");
                                            $(".member_price_widget").removeClass("hidden");
                                            // $(".membership-button-wrap").css("display", "none");
                                            // $(".prd_price_wraper").find(".price-item").addClass("strike_through_activated");

                                          } else {
                                              Swal.fire({
                                                  icon: 'error',
                                                  title: 'Verification Failed',
                                                  text: 'Error verifying passcode. Please try again.',
                                              });
                                          }
                                      },
                                      error: function() {
                                          $('#response').html('Error verifying passcode');
                                          Swal.fire({
                                              icon: 'error',
                                              title: 'Verification Failed',
                                              text: 'Error verifying passcode. Please try again.',
                                          });
                                      }
                                  });
                              } else {
                                  Swal.fire({
                                      icon: 'warning',
                                      title: 'Input Required',
                                      text: 'Please enter the passcode.',
                                  });
                              }
                          });
                      });

                      $(document).ready(function () {
                      // Open popup
                      $('.open_otp_pop').on('click', function () {
                        $('.cst_pop_overlay').fadeIn();
                      });

                      // Close popup
                      $('.cst_pop_close, .cst_pop_overlay').on('click', function (e) {
                        if ($(e.target).is('.cst_pop_close') || $(e.target).is('.cst_pop_overlay')) {
                          $('.cst_pop_overlay').fadeOut();
                        }
                      });
                    });


           function checkVariantMemberPrice() {
           var url = window.location.href;
           var parts = url.split("/");
           var last_part = parts[parts.length - 1];
           var url_variant = last_part.split("=")[1];
           if (url_variant != undefined) {
               $(".m_price_item").hide();
               $(".m_price_item").each(function() {
                   var mvar_id = $(this).attr("data-id");
                   if (mvar_id == url_variant) {
                       $(this).show();
                   }
               });
           }
       }

       checkVariantMemberPrice();

       $(document).on("change", ".product-form__input .select__select", function() {
         setTimeout(function(){
             checkVariantMemberPrice();
         }, 1000);
     });

    let mobile_verified_by_otp = localStorage.getItem('mobile_verified_by_otp');
    if(mobile_verified_by_otp == "1"){
      $(".otp_member_info").addClass("hidden");
      $(".member_price_widget").removeClass("hidden");
      // $(".membership-button-wrap").css("display", "none");
    //   $(".prd_price_wraper").find(".price-item").addClass("strike_through_activated");

    }else{
    //   $(".otp_pop_wraper").css("display", "flex");
    //   $(".member_price_widget").css("display", "none");
    //   // $(".membership-button-wrap").css("display", "block");
    //   $(".prd_price_wraper").find(".price-item").removeClass("strike_through_activated");
    }